export default __webpack_public_path__ + "fec4d794565f408122751c956b4014de.svg";